import { render } from "./PrescriberSignature.vue?vue&type=template&id=407fc9c4&scoped=true"
import script from "./PrescriberSignature.vue?vue&type=script&lang=js"
export * from "./PrescriberSignature.vue?vue&type=script&lang=js"

import "./PrescriberSignature.vue?vue&type=style&index=0&id=407fc9c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407fc9c4"]])

export default __exports__